


const stockSheet = (lines, data) => {
  return (
    `
    <!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
      <head>
        <!--[if gte mso 9]>
            <xml>
                <o:OfficeDocumentSettings>
                <o:AllowPNG/>
                <o:PixelsPerInch>96</o:PixelsPerInch>
                </o:OfficeDocumentSettings>
            </xml>
        <![endif]-->
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta name="x-apple-disable-message-reformatting">
        <!--[if !mso]><!-->
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <!--<![endif]-->
            
            <style type="text/css">
                html {
	box-sizing: border-box;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

            </style>
        
            <style type="text/css">
                *, *::before, *::after {
	box-sizing: inherit;
}

            </style>
        
            <style type="text/css">
                strong, b {
	font-weight: 700;
}

            </style>
        
            <style type="text/css">
                body {
	color: #263238;
	margin: 0;
	font-size: 0.875rem;
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
	font-weight: 400;
	line-height: 1.43;
	letter-spacing: 0.01071em;
	background-color: #fff;
}

            </style>
        
            <style type="text/css">
                @media print {
	body {
		background-color: #fff;
	}
}

            </style>
        
            <style type="text/css">
                body::backdrop {
	background-color: #fff;
}

            </style>
        

        <style type="text/css">
            .mainClass{
                width: 100%
            }
        </style>
        <style type="text/css">
            .braft-output-content p{min-height:1em}.braft-output-content .image-wrap img{max-width:100%;height:auto}.braft-output-content ul,.braft-output-content ol{margin:16px 0;padding:0}.braft-output-content blockquote{margin:0 0 10px 0;padding:15px 20px;background-color:#f1f2f3;border-left:solid 5px #ccc;color:#666;font-style:italic}.braft-output-content pre{max-width:100%;max-height:100%;margin:10px 0;padding:15px;overflow:auto;background-color:#f1f2f3;border-radius:3px;color:#666;font-family:monospace;font-size:14px;font-weight:normal;line-height:16px;}.braft-output-content pre pre{margin:0;padding:0}
            @media  (max-width: 768px) {
                /* For mobile phones: */
                .mainClass {
                    width: 100%;
                }
            }
            @media screen and (max-width: 600px) {
                table td#containerCol {
                    display: flex;
                    width: 100%;
                }
            }
        </style>
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
      <title>${data.reference.split('-')[0]} STOCK SHEET</title>
      </head>
      <body style="
            background-color:#fff;
            background-image: url();
            background-repeat: no-repeat;
            background-size: cover;
            background-attachment: fixed;
            height: 100vh;
        ">
        <div style="text-align: left; width: 100%; height: 20%; font-size: 14px; padding: 10px 0; margin-top: 20px; margin-bottom: 50px;">
          <div style="border-bottom: 1px solid #000;"><img src="" style="width: 90px; height: auto;" alt="Caspian Logo"></div>
          <div style=" font-size: 17px; font-weight: "bold"; margin-top: 5px;">Caspian Outlet Limited</div>
          <div style=" font-size: 15px; font-weight: "bold"; margin-top: 5px;">Ghana</div>
        </div>
        <table style="width:100%;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="center" style="width:100%"><tr><td style="padding:0"><div style="margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div id="Main" class="mainClass"><table style="width:100%;background-image:url();background-color:#ffffff;height:100%;border-radius:0;background-repeat:no-repeat;background-size:cover;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="left" style="width:100%"><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><div><div style="margin-bottom: 12px;">
    <h2 style="font-size: 20px;">${data.reference}</h2>
    <p><span style="font-weight: bold;">Date:</span> ${data.date}</p>
    
</div></div></div></div></td></tr><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><table style="width:100%;background-image:url();background-color:#FFFFFF00;height:100%;border-radius:0;background-repeat:no-repeat;background-size:cover;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="left" style="width:100%"><tr><td width="50%" style="padding:0" id="containerCol"><table style="width:100%;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="left" style="width:100%"><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><table style="width:100%;background-image:url();background-color:#FFFFFF00;height:100%;border-radius:0;background-repeat:no-repeat;background-size:cover;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="left" style="width:100%"><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><div>
  </div></div></div></td></tr></tbody></table></div></div></td></tr></tbody></table></td><td width="50%" style="padding:0" id="containerCol"><table style="width:100%;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="left" style="width:100%"><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><table style="width:100%;background-image:url();background-color:#FFFFFF00;height:100%;border-radius:0;background-repeat:no-repeat;background-size:cover;table-layout:fixed;border-spacing:0" cellSpacing="0"><tbody align="left" style="width:100%"><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><div>
  </div></div></div></td></tr></tbody></table></div></div></td></tr></tbody></table></td></tr></tbody></table></div></div></td></tr><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><div><table style="width:100%;">
  <thead>
    <tr style="text-align:left;">
      <th style="border-bottom: 1px solid gray;">Product</th>
      <th style="border-bottom: 1px solid gray;">Reserved Quantity</th>
      <th style="border-bottom: 1px solid gray;">On Hand Quantity</th>
      <th style="border-bottom: 1px solid gray;">Counted Quantity</th>
      <th style="border-bottom: 1px solid gray;">Difference</th>
      <th style="border-bottom: 1px solid gray;">Stock Value</th>
    </tr>
  </thead>
  <tbody>
    ${lines.map((item, id) =>
      `<tr key=${id}>
        <td>${item.product}</td>
        <td>${item.quantity}</td>
        <td>${item.counted_quantity}</td>
        <td>${item.quantity_difference}</td>
        <td>${new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.stock_value)}</td>
      </tr>`
    ).join('')}
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td>Total Difference</td>
      <td>${new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(lines.reduce((prev, current) => (current.quantity_difference + prev), 0))}</td>
      <td></td>
    </tr>
  </tbody>
</table></div></div></div></td></tr><tr><td style="padding:0"><div style="padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;margin-bottom:0;margin-top:0;margin-right:0;margin-left:0"><div style="width:100%"><div><div>

  <div style="display: flex; text-align: end; width:100%; height: 20%;">
    <p style="width: 73%; font-weight: bold ">Inventory Adjustment Total</p>
    <p style="width: 25%">${new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(lines.reduce((prev, current) => ((current.stock_value*1) + prev), 0))} GHc</p>
  </div>

</div></div></div></div></td></tr></tbody></table></div></div></td></tr></tbody></table>
         <div style="width: 100%; font-size: 12px; text-align: center; margin-bottom: 20px; margin-top: 50px">
        <div style="border-top: 1px solid #000; padding-top: 5px;">https://www.casspian.com</div>
      </div>
      </body>
        <script type="text/javascript">
          var w=window.innerWidth;
          if(w < 800) document.getElementById("Main").className=("MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12");
        </script>
    </html>
  
    `
  )
};


module.exports = stockSheet;